module.exports = "<dbm-edit class=\"exclude-objects-container\" (save)=\"save()\" (cancel)=\"cancel()\">\n    <dbm-table class=\"exclude-objects\" *ngIf=\"dataSource && displayedColumns\"\n               [dataSource]=\"dataSource\"\n               [displayedColumns]=\"displayedColumns\"\n               (removeRowEvent)=\"removeRow($event)\"\n               (addRowEvent)=\"addNewRow($event)\"\n               (selectedValue)=\"selectValue($event)\">\n    </dbm-table>\n    <div>The Schema/Owner Name and Object Name are case sensitive</div>\n</dbm-edit>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/project/exclude-objects/exclude-objects.component.html
// module id = 1775
// module chunks = 0